<template>
  <div
    class="flex min-h-screen items-center justify-center bg-gradient-to-b from-grey-10 to-grey-20"
  >
    <main class="w-full">
      <slot />
    </main>
  </div>
</template>
